export default "__VITE_ASSET__Dl946DcX__"